export const preDefinedThemeColor = {grey: '#F1F2F6', red: '#D00000', orange: '#F17106', green: '#9FD356', blue: '#198FE3', greenArrow: '#41AF36', redArrow: '#E63826',}
